import { useQuery } from '@tanstack/react-query';
import type { FeaturedResponse } from '@pms/shared';
import { getFeatured } from '../services/api/featured.api';

/**
 * Curated data for the homepage "curated hotels" section (TASK-61).
 *
 * Reads GET /v1/public/featured — the super-admin-curated feed (approved,
 * active, not-hidden properties in curated order, plus the single Editor's
 * Pick). Enforcement lives server-side, so demo / hidden / regressed properties
 * never appear. `CuratedHotels` renders `editorsPick` (or the first item) as the
 * banner and the remaining `items` as the grid; it degrades to a calm empty /
 * static fallback when the feed is empty or unreachable.
 */
export function useFeaturedStays() {
  return useQuery<FeaturedResponse>({
    queryKey: ['featured'],
    queryFn: getFeatured,
    staleTime: 5 * 60 * 1000,
  });
}
